import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { I18nProvider } from '../contexts/I18nContext';
import { UserPreferencesProvider } from '../contexts/UserPreferencesContext';
import { ToastProvider } from '../contexts/ToastContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <I18nProvider>
      <UserPreferencesProvider>
        <ToastProvider>
          <AppShell />
          <TanStackRouterDevtools position="bottom-right" />
        </ToastProvider>
      </UserPreferencesProvider>
    </I18nProvider>
  );
}

function AppShell() {
  useDocumentTitle(); // Needs to be inside the I18nProvider

  return <Outlet />;
}
